import { StateType } from '../state/state_type.enum'
import { StateMapDisk, WORKSPACE_DISK_PLACEHOLDER_ERROR } from '../state/state_map_disk.enum'
import { Disk } from './Disk.interface'
import { gameDisk, lobbyDisk, mapDisk, replayDisk } from './IndexedDBDisk'
import { memoryGameDisk, memoryLobbyDisk, memoryMapDisk, memoryReplayDisk } from './MemoryDisk'

export function getStateDiskByType(diskType: StateMapDisk, stateType: StateType): Disk {
  switch (diskType) {
    case StateMapDisk.IndexedDB:
      return getIndexedDBDiskByStateType(stateType)
    case StateMapDisk.Memory:
      return getMemoryDiskByStateType(stateType)
    case StateMapDisk.Cloud:
      throw new Error('Cloud disk is not available through the local disk resolver')
    case StateMapDisk.Export:
      throw new Error('Export disk placeholder is not available through the local disk resolver')
    case StateMapDisk.Workspace:
      throw new Error(WORKSPACE_DISK_PLACEHOLDER_ERROR)
  }
}

function getIndexedDBDiskByStateType(stateType: StateType): Disk {
  switch (stateType) {
    case StateType.Map:
      return mapDisk
    case StateType.Lobby:
      return lobbyDisk
    case StateType.Game:
      return gameDisk
    case StateType.Replay:
      return replayDisk
  }
}

function getMemoryDiskByStateType(stateType: StateType): Disk {
  switch (stateType) {
    case StateType.Map:
      return memoryMapDisk
    case StateType.Lobby:
      return memoryLobbyDisk
    case StateType.Game:
      return memoryGameDisk
    case StateType.Replay:
      return memoryReplayDisk
  }
}
